// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__syoDR","comment":"styles_comment__3pYgo"};